/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { ICustomerEntity, ICreateCustomerPayload, IUpdateCustomerPayload, IListCustomersPayload, ICustomerListResponse } from "./customers.interface";
import { Environment } from "../../../Config/constants";

export class CustomersApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public destroy = async (customerId: string): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/customers/${customerId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreateCustomerPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/customers`, data );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async ({ page, searchBy, personType}: IListCustomersPayload): Promise<Result<ICustomerListResponse>> => {
    try {
        const response = await this.service.get(`/customers`, { params: { 
          offset: Number(Environment.OFFSET_REGISTERS),
          page,
          searchBy,
          personType
        }});

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (customerId: string): Promise<Result<ICustomerEntity>> => {
    try {
        const response = await this.service.get(`/customers/${customerId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async (data: IUpdateCustomerPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/customers/${data.id}`, data );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
